import { Link } from "react-router-dom"

import { styled, Typography } from "@l2r-front/l2r-ui"

export const Wrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    gap: theme.spacing(3),
}))

export const Header = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
    gap: theme.spacing(3),
}))

export const LinkText = styled(Typography)({
    color: "inherit",
    textDecoration: "underline",
})

export const InfoLink = styled(Link)({
    color: "inherit",
    textDecoration: "underline",
})
